import { GeofenceEntity, geofenceTriggerType } from "@ots-frontend/ots-data";
import { Circle } from "@react-google-maps/api";
import React, {useCallback, useEffect, useState} from "react";
import { shiftStartColor } from "../../../../theme/colors";
import { EntityMarker, EntityMarkerProps } from "../EntityMarker/EntityMarker";
import { getDefaultMarkerIcon, MarkerIcon } from "../Marker/Marker";

export type GeofenceMarkerProps = Omit<
  EntityMarkerProps<GeofenceEntity>,
  "icon" | "position"
> & {
  showGeofence?: boolean;
};

export const GeofenceMarker = (props: GeofenceMarkerProps) => {
  const {
    entity,
    showGeofence,
    ...rest
  } = props;

  const [icon, setIcon] = useState<MarkerIcon>(getDefaultMarkerIcon());
  const [location, setLocation] = useState<
    google.maps.LatLng | google.maps.LatLngLiteral
  >({
    lat: entity.latLng.latCoord,
    lng: entity.latLng.longCoord
  });

  useEffect(() => {
    setLocation({
      lat: entity.latLng.latCoord,
      lng: entity.latLng.longCoord
    });
  }, [entity]);

  const getIcon = useCallback((entity: GeofenceEntity) => {
    let markerIcon = getDefaultMarkerIcon();

    if (entity.triggerType.code === geofenceTriggerType.onSiteStart.code) {
      markerIcon = getDefaultMarkerIcon(shiftStartColor);
    }

    return markerIcon;
  }, [])

  return (
    <>
      <EntityMarker
        {...rest}
        entity={entity}
        icon={getIcon}
        position={location}
      />
      {showGeofence && (
        <Circle
          center={location}
          radius={entity.radius}
          options={{ clickable: false }}
        />
      )}
    </>
  );
};

export const GeofenceMarkerMemo = React.memo(
  GeofenceMarker,
  (prevProps, props) =>
    prevProps.entity.id === props.entity.id &&
    prevProps.entity.latCoord === props.entity.longCoord &&
    prevProps.entity.longCoord === props.entity.longCoord &&
    prevProps.entity.radius === props.entity.radius &&
    prevProps.entity.triggerType === props.entity.triggerType
);
